import { useEffect, useState } from "react";
import { NoAlarmEventsTips, AlarmEventListWrapper, AlarmEventItem, AlarmEventItemRow, DeviceName, AlarmEventTime, AlarmEventDetails } from "./AlarmEventList.styled";
import AlarmEventApi from "../../../../../../api/AlarmEventApi";
import TimeUtils from "../../../../../../util/TimeUtils";
import ViewStateService from "../../../../../../services/view-state/ViewStateService";
import { useNavigate } from "react-router-dom";

interface AlarmEventListProps {

}

let AlarmEventList: React.FC<AlarmEventListProps> = (props)=> {

    // api
    let alarmEventApi = new AlarmEventApi();
    let navigate = useNavigate();

    // state
    let [unackedEventViews, setUnackedEventViews] = useState<any[]>([]);

    // function
    let loadAlarmEventViews = async ()=> {
        let alarmEvents = (await alarmEventApi.queryViews({
            acked: false,
            pageNo: 1,
            pageSize: 20,
        })).data.data.elements;
        setUnackedEventViews(alarmEvents);
        ViewStateService.getInstance().fireAlarmEventsListeners(alarmEvents);
    };
    
    // effect
    useEffect(()=> {
        loadAlarmEventViews();

        // refresh task
        let refreshInterval = window.setInterval(()=> {
            loadAlarmEventViews();
        }, 5000);

        return ()=> {
            window.clearInterval(refreshInterval);
        }
    }, []);

    // render
    return <AlarmEventListWrapper>
        {
            unackedEventViews.map((eventView)=> {
                return <AlarmEventItem key={eventView.event.id} onClick={()=> navigate('/alarm-events')}>
                    <AlarmEventItemRow>
                        <DeviceName>{eventView.device?.name}</DeviceName>
                        <AlarmEventTime>{TimeUtils.formatLastTime(eventView.event.startTime)} </AlarmEventTime>
                    </AlarmEventItemRow>

                    <AlarmEventItemRow>
                        <AlarmEventDetails>{eventView.event.details}</AlarmEventDetails>
                    </AlarmEventItemRow>
                </AlarmEventItem>
            })
        }

        {
            unackedEventViews.length <= 0 && <NoAlarmEventsTips>暂无告警</NoAlarmEventsTips>
        }
    </AlarmEventListWrapper>
};

export default AlarmEventList;
